import React from "react";
import FlightCardBoundMobile from "./components/FlightCardBound.js";
import Frame from "../Frame/index.js";
import useFlightCardMobileController from "./useFlightCard.mobile.controller.js";
const _FlightCardMobile = (props) => {
    const { ariaLabel, bigLogo, flight, forceHideLastAvailableSeats, handleOnClick, index, isAlternativeFareCard, mb, mt, ref, searchType } = useFlightCardMobileController(props);
    const { outboundBrandedFareName } = props;
    return (React.createElement(Frame, { mt: mt !== undefined ? mt : 2, mb: mb !== undefined ? mb : 4, elementRef: ref, attributes: { role: "group", "aria-label": ariaLabel } },
        React.createElement(FlightCardBoundMobile, { flight: flight, onClick: handleOnClick, pricePerPerson: true, index: index, bigLogo: bigLogo, searchType: searchType, outboundBrandedFareName: outboundBrandedFareName, forceHideLastAvailableSeats: forceHideLastAvailableSeats, isAlternativeFareCard: isAlternativeFareCard, boundsVariant: props.boundsVariant })));
};
const FlightCardMobile = React.memo(_FlightCardMobile);
export default FlightCardMobile;
